<section class="dash-page">
  <main class="dash-container">
    <app-filter-dashboard (changesDates)="changesDate($event)"
                          [suggestions]="true">
      <p-dropdown [options]="filterDependencias" optionLabel="descripcion" styleClass="md:w-full lg:w-18rem"
                  [showClear]="true" (onChange)="changeFilterDeps($event.value)"
                  [placeholder]="'common.dependencia' | translate" (onClear)="clearFilterDependencias()"
                  optionValue="value"></p-dropdown>

    </app-filter-dashboard>

    <div class="grid col-12">
      @for (card of displayedCards; track card.dependenciaId) {
        <div class="col-12 sm:col-6  md:col-4 lg:col-3">
          <div class="dash-card h-full">
            <div class="dash-header">
              <div class="w-full">
                <h2 class="dash-title text-center">{{ card.dependenciaNombre }}</h2>
              </div>
            </div>
            <div class="dash-body">
              <app-chart-donut #donutChart [config]="card.config"/>
            </div>
            <div class="dash-footer flex justify-content-center">
              <button type="button" pButton
                      class="p-button w-12rem p-button-outlined"
                      (click)="verDetalle(card.dependenciaId, card.dependenciaNombre)">
                {{ translations.verDetalle }}
              </button>
            </div>
          </div>
        </div>

      } @empty {
        @if (!isLoading) {
          <div class="border-round-2xl border-2 col-12 border-yellow-400 bg-yellow-50 px-4 my-3 py-3 mx-auto">
            <h3 class="text-yellow-600 mb-0 text-2xl font-weight-medium">{{ 'msg.busqueda-sin-datos' | translate }}</h3>
            <p class="text-yellow-600 text-lg pt-1">{{ 'msg.no-se-encontraron-datos' | translate }}</p>
          </div>
        }
      }
    </div>
  </main>
</section>
